import { PERSONA_ROLE_LABELS_DE } from "@kmu-trexpert/shared";
import i18n from "i18next";

import deCommon from "./locales/de-CH/common.json";
import deNavigation from "./locales/de-CH/navigation.json";

// The demo-app host is plain DOM (no React), so it needs only a bare i18next
// instance — not initReactI18next. These keys are a deliberate, minimal copy of
// the host-facing strings from packages/client's i18n; the touchpoint UI keeps
// its own full i18n inside the MFE. Keep the German values in sync with
// packages/client/src/i18n/locales/de-CH/{common,navigation}.json.
void i18n.init({
    lng: "de-CH",
    fallbackLng: "de-CH",
    ns: ["common", "navigation"],
    defaultNS: "common",
    resources: {
        "de-CH": {
            common: deCommon,
            // personaRole labels come from the shared single source so the host
            // shell and the client touchpoints never drift (see PERSONA_ROLE_LABELS_DE).
            navigation: { ...deNavigation, personaRole: PERSONA_ROLE_LABELS_DE },
        },
    },
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
